import { useContext } from 'react';

import dynamic from 'next/dynamic';

import { AppContext } from '../../../context/';

// const Mobile = dynamic(() => import('./Mobile'));

const Dekstop = dynamic(() => import('./Dekstop'));

function Modal(props) {
  const { isMobile } = useContext(AppContext);

  if (isMobile) {
    return <Dekstop {...props} />;
  }

  return <Dekstop {...props} />;
}

export default Modal;
